import { useState, useEffect } from "react";
import { useParams } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import SubscriptionsDetails from "../../components/subscriptions/SubscriptionsDetail";
import api from "../../services/api";

export default function SubscriptionDetailsPage() {
    const { id } = useParams<{ id: string }>();
    const [subscriptionData, setSubscriptionData] = useState<any>(null);
    const [loading, setLoading] = useState<boolean>(true);
    const [error, setError] = useState<string | null>(null);

    useEffect(() => {
        const fetchSubscriptionDetails = async () => {
            if (!id) {
                setError('ID da assinatura não fornecido');
                setLoading(false);
                return;
            }

            try {
                setLoading(true);
                setError(null);

                const response = await api.get(`/api/subscriptions/${id}/details`);

                if (response.data && response.data.status === 'success') {
                    setSubscriptionData(response.data.data);
                } else {
                    setError('Erro ao carregar dados da assinatura');
                }
            } catch (err: any) {
                console.error('Erro ao buscar detalhes da assinatura:', err);

                // Tratamento de erro mais específico
                if (err.response?.status === 404) {
                    setError('Assinatura não encontrada');
                } else if (err.response?.status === 403) {
                    setError('Você não tem permissão para visualizar esta assinatura');
                } else {
                    setError('Erro ao carregar dados da assinatura. Tente novamente.');
                }
            } finally {
                setLoading(false);
            }
        };

        fetchSubscriptionDetails();
    }, [id]);

    return (
        <>
            <PageMeta
                title="Sellyo - Detalhes da Assinatura"
                description="Detalhes da assinatura"
            />
            <div className="grid grid-cols-12 gap-4 md:gap-6">
                <div className="col-span-12">
                    {loading ? (
                        <div className="flex justify-center items-center h-64">
                            <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
                            <span className="ml-4 text-gray-600 dark:text-gray-400">Carregando detalhes da assinatura...</span>
                        </div>
                    ) : error ? (
                        <div className="rounded-2xl border border-red-200 bg-red-50 p-6 dark:border-red-800 dark:bg-red-900/20">
                            <div className="flex items-center">
                                <svg className="h-5 w-5 text-red-600 dark:text-red-400 mr-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" />
                                </svg>
                                <div>
                                    <h3 className="text-sm font-medium text-red-800 dark:text-red-200">Erro ao carregar assinatura</h3>
                                    <p className="mt-1 text-sm text-red-700 dark:text-red-300">{error}</p>
                                </div>
                            </div>
                        </div>
                    ) : subscriptionData ? (
                        <SubscriptionsDetails subscriptionData={subscriptionData} />
                    ) : (
                        <div className="text-center p-8">
                            <p className="text-gray-500 dark:text-gray-400">Nenhum dado disponível</p>
                        </div>
                    )}
                </div>
            </div>
        </>
    );
}